module.exports = __webpack_public_path__ + "img/按钮6.2d3608fa.png";